import { createContext } from 'react';

export type SettingsContextType = {
  directories: {
    id: number;
    name: string;
    emailAccountSuffix: string;
    formattedName: string;
  }[];
  reloadSettings: () => Promise<void>;
};

export const SettingsContext = createContext<SettingsContextType>({} as any);
